import moment from 'moment';
import {COMCYCLE} from "@/actions/globalConst";

export let calenderSettings = localStorage.getItem("calender_settings");

if(calenderSettings) {
    calenderSettings = JSON.parse(calenderSettings);
}


    class CommunicationCycleInit  {
    selected= false;
    item= null;
    items= [];
    users= null;
    selectedUsers= [];
    schedule= null;
    priority= false;
    event_types= false;
    view= COMCYCLE.VIEW_OVERVIEW;
    apiState= COMCYCLE.API_INIT;
    selectedDate= moment(); 
    key= "";
    error= null;
    calenderSettings= calenderSettings;
    needToUpdate = true;
    dragItem = null;
    dragOverElement = null;
            
      


    }
    
export default new CommunicationCycleInit();     